import { render, staticRenderFns } from "./batch_work_edit.vue?vue&type=template&id=1a4efd0e&scoped=true"
import script from "./batch_work_edit.vue?vue&type=script&lang=js"
export * from "./batch_work_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4efd0e",
  null
  
)

export default component.exports